import React from "react";
import $ from "jquery";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import Cta from "../../Shared/Cta";

const AllBook = () => {
  useEffect(() => {
    $(".checkAll").on("click", function () {
      $(this)
        .parents(".table")
        .find("input:checkbox")
        .prop("checked", this.checked);
    });
  }, []);
  return (
    <>
      <div class="breadcrumbs-area">
        <h3>Library</h3>
        <ul>
          <li>
            <Link to="/admin">Home</Link>
          </li>
          <li>All Library Books</li>
        </ul>
      </div>

      <div class="card height-auto">
        <div class="card-body">
          <div class="heading-layout1">
            <div class="item-title">
              <h3>All Books</h3>
            </div>
            <Cta />
          </div>
          <form class="mg-b-20">
            <div class="row gutters-8">
              <div class="col-3-xxxl col-xl-3 col-lg-3 col-12 form-group">
                <input
                  type="text"
                  placeholder="Search by ID ..."
                  class="form-control"
                />
              </div>
              <div class="col-4-xxxl col-xl-4 col-lg-3 col-12 form-group">
                <input
                  type="text"
                  placeholder="Search by Name ..."
                  class="form-control"
                />
              </div>
              <div class="col-4-xxxl col-xl-3 col-lg-3 col-12 form-group">
                <input
                  type="text"
                  placeholder="Search by Phone ..."
                  class="form-control"
                />
              </div>
              <div class="col-1-xxxl col-xl-2 col-lg-3 col-12 form-group">
                <button type="submit" class="fw-btn-fill btn-gradient-yellow">
                  SEARCH
                </button>
              </div>
            </div>
          </form>
          <div class="table-responsive">
            <table class="table display data-table text-nowrap">
              <thead>
                <tr>
                  <th>
                    <div class="form-check">
                      <input
                        type="checkbox"
                        class="form-check-input checkAll"
                      />
                      <label class="form-check-label">ID</label>
                    </div>
                  </th>
                  <th>Book Name</th>
                  <th>Subject</th>
                  <th>Writter</th>
                  <th>Class</th>
                  <th>Published</th>
                  <th>Creating Date</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" />
                      <label class="form-check-label">#0021</label>
                    </div>
                  </td>
                  <td>English Grammer</td>
                  <td>English</td>
                  <td>David Morgan</td>
                  <td>5</td>
                  <td>2019</td>
                  <td>12.02.2019</td>
                  <td>
                    <Cta />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" />
                      <label class="form-check-label">#0022</label>
                    </div>
                  </td>
                  <td>Expert Mathmetic</td>
                  <td>Math</td>
                  <td>Robert John</td>
                  <td>8</td>
                  <td>2019</td>
                  <td>02.02.2019</td>
                  <td>
                    <Cta />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" />
                      <label class="form-check-label">#0023</label>
                    </div>
                  </td>
                  <td>Bangla Grammer</td>
                  <td>Bangla</td>
                  <td>Kazi Fahim</td>
                  <td>2</td>
                  <td>2017</td>
                  <td>05.01.2019</td>
                  <td>
                    <Cta />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" />
                      <label class="form-check-label">#0024</label>
                    </div>
                  </td>
                  <td>English Grammer</td>
                  <td>English</td>
                  <td>David Morgan</td>
                  <td>5</td>
                  <td>2018</td>
                  <td>12.02.2019</td>
                  <td>
                    <Cta />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" />
                      <label class="form-check-label">#0025</label>
                    </div>
                  </td>
                  <td>Computer Science</td>
                  <td>Science</td>
                  <td>David Morgan</td>
                  <td>5</td>
                  <td>2018</td>
                  <td>12.02.2019</td>
                  <td>
                    <Cta />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" />
                      <label class="form-check-label">#0021</label>
                    </div>
                  </td>
                  <td>English Grammer</td>
                  <td>English</td>
                  <td>David Morgan</td>
                  <td>5</td>
                  <td>2019</td>
                  <td>12.02.2019</td>
                  <td>
                    <Cta />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" />
                      <label class="form-check-label">#0022</label>
                    </div>
                  </td>
                  <td>Expert Mathmetic</td>
                  <td>Math</td>
                  <td>Robert John</td>
                  <td>8</td>
                  <td>2019</td>
                  <td>02.02.2019</td>
                  <td>
                    <Cta />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" />
                      <label class="form-check-label">#0023</label>
                    </div>
                  </td>
                  <td>Bangla Grammer</td>
                  <td>Bangla</td>
                  <td>Kazi Fahim</td>
                  <td>2</td>
                  <td>2017</td>
                  <td>05.01.2019</td>
                  <td>
                    <Cta />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" />
                      <label class="form-check-label">#0024</label>
                    </div>
                  </td>
                  <td>English Grammer</td>
                  <td>English</td>
                  <td>David Morgan</td>
                  <td>5</td>
                  <td>2018</td>
                  <td>12.02.2019</td>
                  <td>
                    <Cta />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" />
                      <label class="form-check-label">#0025</label>
                    </div>
                  </td>
                  <td>Computer Science</td>
                  <td>Science</td>
                  <td>David Morgan</td>
                  <td>5</td>
                  <td>2018</td>
                  <td>12.02.2019</td>
                  <td>
                    <Cta />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" />
                      <label class="form-check-label">#0021</label>
                    </div>
                  </td>
                  <td>English Grammer</td>
                  <td>English</td>
                  <td>David Morgan</td>
                  <td>5</td>
                  <td>2019</td>
                  <td>12.02.2019</td>
                  <td>
                    <Cta />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" />
                      <label class="form-check-label">#0022</label>
                    </div>
                  </td>
                  <td>Expert Mathmetic</td>
                  <td>Math</td>
                  <td>Robert John</td>
                  <td>8</td>
                  <td>2019</td>
                  <td>02.02.2019</td>
                  <td>
                    <Cta />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" />
                      <label class="form-check-label">#0023</label>
                    </div>
                  </td>
                  <td>Bangla Grammer</td>
                  <td>Bangla</td>
                  <td>Kazi Fahim</td>
                  <td>2</td>
                  <td>2017</td>
                  <td>05.01.2019</td>
                  <td>
                    <Cta />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" />
                      <label class="form-check-label">#0024</label>
                    </div>
                  </td>
                  <td>English Grammer</td>
                  <td>English</td>
                  <td>David Morgan</td>
                  <td>5</td>
                  <td>2018</td>
                  <td>12.02.2019</td>
                  <td>
                    <Cta />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" />
                      <label class="form-check-label">#0025</label>
                    </div>
                  </td>
                  <td>Computer Science</td>
                  <td>Science</td>
                  <td>David Morgan</td>
                  <td>5</td>
                  <td>2018</td>
                  <td>12.02.2019</td>
                  <td>
                    <Cta />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" />
                      <label class="form-check-label">#0021</label>
                    </div>
                  </td>
                  <td>English Grammer</td>
                  <td>English</td>
                  <td>David Morgan</td>
                  <td>5</td>
                  <td>2019</td>
                  <td>12.02.2019</td>
                  <td>
                    <Cta />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" />
                      <label class="form-check-label">#0022</label>
                    </div>
                  </td>
                  <td>Expert Mathmetic</td>
                  <td>Math</td>
                  <td>Robert John</td>
                  <td>8</td>
                  <td>2019</td>
                  <td>02.02.2019</td>
                  <td>
                    <Cta />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" />
                      <label class="form-check-label">#0023</label>
                    </div>
                  </td>
                  <td>Bangla Grammer</td>
                  <td>Bangla</td>
                  <td>Kazi Fahim</td>
                  <td>2</td>
                  <td>2017</td>
                  <td>05.01.2019</td>
                  <td>
                    <Cta />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" />
                      <label class="form-check-label">#0024</label>
                    </div>
                  </td>
                  <td>English Grammer</td>
                  <td>English</td>
                  <td>David Morgan</td>
                  <td>5</td>
                  <td>2018</td>
                  <td>12.02.2019</td>
                  <td>
                    <Cta />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" />
                      <label class="form-check-label">#0025</label>
                    </div>
                  </td>
                  <td>Computer Science</td>
                  <td>Science</td>
                  <td>David Morgan</td>
                  <td>5</td>
                  <td>2018</td>
                  <td>12.02.2019</td>
                  <td>
                    <Cta />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" />
                      <label class="form-check-label">#0025</label>
                    </div>
                  </td>
                  <td>Computer Science</td>
                  <td>Science</td>
                  <td>David Morgan</td>
                  <td>5</td>
                  <td>2018</td>
                  <td>12.02.2019</td>
                  <td>
                    <Cta />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" />
                      <label class="form-check-label">#0021</label>
                    </div>
                  </td>
                  <td>English Grammer</td>
                  <td>English</td>
                  <td>David Morgan</td>
                  <td>5</td>
                  <td>2019</td>
                  <td>12.02.2019</td>
                  <td>
                    <Cta />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" />
                      <label class="form-check-label">#0022</label>
                    </div>
                  </td>
                  <td>Expert Mathmetic</td>
                  <td>Math</td>
                  <td>Robert John</td>
                  <td>8</td>
                  <td>2019</td>
                  <td>02.02.2019</td>
                  <td>
                    <Cta />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" />
                      <label class="form-check-label">#0023</label>
                    </div>
                  </td>
                  <td>Bangla Grammer</td>
                  <td>Bangla</td>
                  <td>Kazi Fahim</td>
                  <td>2</td>
                  <td>2017</td>
                  <td>05.01.2019</td>
                  <td>
                    <Cta />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" />
                      <label class="form-check-label">#0024</label>
                    </div>
                  </td>
                  <td>English Grammer</td>
                  <td>English</td>
                  <td>David Morgan</td>
                  <td>5</td>
                  <td>2018</td>
                  <td>12.02.2019</td>
                  <td>
                    <Cta />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" />
                      <label class="form-check-label">#0025</label>
                    </div>
                  </td>
                  <td>Computer Science</td>
                  <td>Science</td>
                  <td>David Morgan</td>
                  <td>5</td>
                  <td>2018</td>
                  <td>12.02.2019</td>
                  <td>
                    <Cta />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default AllBook;
